import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-jjsv-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './jjsv-loader.component.html',
  styleUrl: './jjsv-loader.component.scss',
})
export class JjsvLoader {
  @Input() isLoading: boolean = true;
  @Input() message: string = 'Loading...';
}
